import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isMobileOrTablet: undefined,
    isMobileOrPortrait: undefined,
    popup: null,
    popupContent: {},
    calendar: null,
    live_event: null,
    new_events: null,
    popular_events: null,
    pageIsHidden: false,
    tags: null,
  },
  mutations: {
    updateIsMobileOrTablet(state, flag) {
      state.isMobileOrTablet = flag;
      window.isMobileOrTablet = flag;
    },
    updateIsMobileOrPortrait(state, flag) {
      state.isMobileOrPortrait = flag;
    },

    pageHidden(state) {
      let offset = window.pageYOffset;
      document.documentElement.classList.add('hidden');
      state.windowOffset = offset;
      state.pageIsHidden = true;
      document.querySelector('#app').style.cssText = 'position: fixed;top: -' + offset + 'px';
    },
    pageDelHidden(state) {
      document.documentElement.classList.remove('hidden');
      state.pageIsHidden = false;
      document.querySelector('#app').style.cssText = 'position: relative;  top: 0px';
      window.scrollTo(0, state.windowOffset);
    },

    openPopup(state, popup) {
      state.popup = popup;
    },
    setPopupContent(state, popupContent) {
      state.popupContent = popupContent;
    },
    closePopup(state) {
      state.popup = null;
      state.popupContent = {};
    },

    setCalendar(state, calendar){
      state.calendar = calendar.MONTHS;
      state.new_events = calendar.NEW_EVENTS;
      state.popular_events = calendar.POPULAR_EVENTS;
      state.live_event = calendar.LIVE_EVENT;
      state.tags = calendar.TAG_LIST.map(el => ({
        name: el,
        status: false
      }));
    },

    changeFilterStatus(state, filter) {
      const index = state.tags.findIndex(el => el.name === filter.name)
      state.tags[index].status = !filter.status
    }

  },
  actions: {
    async fetchCalendar({commit}) {
      try {
        let {data} = await Vue.axios.get('?ACTION=getEventCalendar');
        if (data.STATUS === 'ok') {
          commit('setCalendar', data.DATA);
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
  modules: {
  }
})
